<template>
    <a-form-model-item
        :label="field.fieldName"
        :prop="field.fieldCode">
        <!-- 编辑模式 -->
        <template v-if="isFieldEdit">
            <SdSelectCascadeRule
                style="min-width: 180px"
                :value="value"
                :field="field"
                :selectFieldConfig="selectFieldConfig"
                @update:value="updateValue"
                @onValidate="onValidate"/>
        </template>
        <!-- 查看模式 -->
        <template v-else>
            <!-- 过滤器类型为公海时，唯一字段加密 -->
            <template v-if="filterType === 2 && field.uniqueCheck">
                <span class="text-copy">{{encryptedRender(value)}}</span>
            </template>
            <!-- 加密字段 -->
            <template v-else-if="Number(field.currentRoleIsEncrypted)">
                <template v-if="value || value === 0">
                    <span class="text-copy"
                          v-if="Number(field.currentRoleIsShowCopyButton) && isCopy"
                          @click="handleCopy(copyObject)">
                        <a-icon type="copy" />
                        {{encryptedRender(value)}}
                    </span>
                    <span class="text-copy" v-else>{{encryptedRender(value)}}</span>
                </template>
                <template v-else>
                    <span>-</span>
                </template>
            </template>
            <!-- 字段配置：字段可复制 -->
            <template v-else-if="isClipboard && isCopy">
                <span v-if="value || value === 0"
                      class="text-copy"
                      @click="handleCopy(copyObject)">
                    <a-icon type="copy" />
                    {{setOptionsText(value, field)}}
                </span>
                <span v-else>-</span>
            </template>
            <template v-else>
                <span>{{setOptionsText(value, field) || '-'}}</span>
            </template>
        </template>
    </a-form-model-item>
</template>

<script>
    import { encryptedRender } from '@/utils/dynamic'
    import { getRSAData } from '@/utils/index'

    export default {
        name: 'FormItemSelect',
        components: {
            SdSelectCascadeRule: () => import(/* webpackChunkName: "SdSelectCascadeRule" */ './DataEntry/SdSelectCascadeRule'),
        },
        props: {
            value: {
                type: [String, Number]
            },
            field: {
                type: Object,
                required: true
            },
            // 是否切换为编辑
            isEdit: {
                type: Boolean,
                default: false
            },
            // 是否全部字段可编辑
            isAllModify: {
                type: Boolean,
                default: false
            },
            filterType: {
                type: Number,
                default: 0
            },
            outBoundLoading: {
                type: Boolean,
                default: false
            },
            // 是否可复制
            isCopy: {
                type: Boolean,
                default: true
            },
            // 下拉字段规则字段配置
            selectFieldConfig: {
                type: Object,
                default: () => {}
            },
            //加密码
            copyValue: {
                type: String,
                default: '',
            },
        },
        computed: {
            // 模式：true编辑模式 false查看模式
            isFieldEdit() {
                return this.isEdit && (this.isAllModify || Boolean(Number(this.field.isModify)))
            },
            // 字段配置：是否可复制
            isClipboard() {
                const commonProperties = JSON.parse(this.field.commonProperties || "{\"options\":{}}")
                return commonProperties.options.clipboard
            },
            copyObject() {
                return {
                    ...(this.field.copyObject || {}),
                    copyFieldValue: this.copyValue ? getRSAData(this.copyValue) : this.value
                }
            }
        },
        methods: {
            encryptedRender,
            getRSAData,
            setOptionsText(value, field) {
                if (['select', 'checkbox', 'radio'].includes(field.fieldFormType)) {
                    let text = ''
                    // const values = (value.toString()).split(',').map(Number)
                    const values = value ? [value] : []
                    const options = JSON.parse(field.options)
                    for (let i = 0, len = options.length; i < len; i++) {
                        if (values.includes(options[i].value)) {
                            text += `${options[i].label}，`
                        }
                    }
                    return text.substring(0, text.length - 1)
                }
                else if (['region'].includes(field.fieldFormType)) {
                    if (value) {
                        let regionText = '', regionOptions = JSON.parse(value)
                        regionOptions.forEach(item => {
                            regionText += `${item.name}/`
                        })
                        return regionText.substring(0, regionText.length - 1)
                    }
                    else {
                        return '-'
                    }
                }
                else if (['cascade'].includes(field.fieldFormType)) {
                    if (value) {
                        let regionText = '', regionOptions = JSON.parse(value)
                        regionOptions.forEach(item => {
                            regionText += `${item.label}/`
                        })
                        return regionText.substring(0, regionText.length - 1)
                    }
                    else {
                        return '-'
                    }
                }
                else {
                    return value
                }
                return '-'
            },
            updateValue(val) {
                this.$emit('update:value', val)
            },
            onValidate() {
                this.$emit('validateField', this.field.fieldCode)
            },
        }
    }
</script>

<style scoped lang="less">

</style>
